import React from 'react';
export function Footer() {
  return <footer className="bg-black border-t border-zinc-900 py-10 px-4 text-center" data-id="element-117" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-zinc-300" data-id="element-118" data-mp="3gg11ma61ua0t">© MMA Coach Ready 2026 — All rights reserved.</p>
      <p className="text-xs text-zinc-500 mt-2" data-id="element-119" data-mp="32ovvcp86ejhi">
        MMA Coach Ready is an independent coaching resource and is not affiliated with UFC or any
        professional fighting promotion.
      </p>
    </footer>;
}